import React from 'react'
import { NumberTextBox } from '../../TextBox/NumberTextBox'
import { ISchoolTabItemProps } from './SchoolTabItem.types'

const VCESchoolResultTabItem: React.FC<ISchoolTabItemProps> = ({
  results,
  onChange,
}) => (
  <>
    <NumberTextBox
      labelText="Median study score"
      value={results.median_study_score}
      onChange={(v) => onChange({ median_study_score: v })}
    />
    <NumberTextBox
      labelText="Over 40 study score %"
      value={results.over_forty_study_scores_percent}
      onChange={(v) => onChange({ over_forty_study_scores_percent: v })}
    />
    <NumberTextBox
      labelText="VCE Students Applied for Tertiary %"
      value={results.vceStudentsAppliedForTertiaryPlacesPercent}
      onChange={(v) =>
        onChange({ vceStudentsAppliedForTertiaryPlacesPercent: v })
      }
    />
    <NumberTextBox
      labelText="VEC Students Enrolled Level 3-4"
      value={results.vceStudentsEnrolledLevel3to4}
      onChange={(v) => onChange({ vceStudentsEnrolledLevel3to4: v })}
    />
    <NumberTextBox
      labelText="VET Students Enrolled"
      value={results.vetStudentsEnrolled}
      onChange={(v) => onChange({ vetStudentsEnrolled: v })}
    />
    <NumberTextBox
      labelText="VET Competency Completed %"
      value={results.vetCompetencyCompletedPercent}
      onChange={(v) => onChange({ vetCompetencyCompletedPercent: v })}
    />
  </>
)

export { VCESchoolResultTabItem }
